module.exports = require('./helpers/bundle-url').getBundleURL('aHO5m') + "logo-dark.eefe0b7f.svg";